import { DialogProps } from "../../types/dialog-types";
import { getTigerResource } from "../../utils/tigerResource";
import { acrylicStyles, acrylicTokens } from "../../theme/acrylic";

export interface ExitAppDialogProps extends DialogProps {
  onOk?: () => void;
  onCancel?: () => void;
}

const styles = {
  ...acrylicStyles,
  // Plain flex-centred overlay card (not absolute-positioned): keep the
  // centering mechanics and restyle only the surface to acrylic.
  overlay: {
    ...acrylicStyles.overlay,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dialog: {
    background: acrylicTokens.surface,
    backdropFilter: acrylicTokens.surfaceBlur,
    WebkitBackdropFilter: acrylicTokens.surfaceBlur,
    border: acrylicTokens.surfaceBorder,
    borderRadius: acrylicTokens.surfaceRadius,
    width: 360,
    maxWidth: "92vw",
    boxShadow: acrylicTokens.surfaceShadow,
    overflow: "hidden" as const,
  },
  body: {
    padding: "20px 24px",
    display: "flex",
    alignItems: "center",
    gap: 14,
  },
  icon: {
    fontSize: 28,
    color: "#f59e0b",
    lineHeight: 1,
    flexShrink: 0,
  },
  message: {
    fontSize: 14,
    color: "#4b5260",
  },
} as const;

export function ExitAppDialog({
  open,
  onClose,
  onOk,
  onCancel,
}: ExitAppDialogProps) {
  const handleOk = () => {
    onOk?.();
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  if (!open) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div
        style={styles.dialog}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label={getTigerResource("TIGER_EXIT_TITLE")}
      >
        {/* Header */}
        <div style={styles.header}>
          <span style={styles.title}>{getTigerResource("TIGER_EXIT_TITLE")}</span>
          <button className="acrylic-close-btn" onClick={onClose}>
            &#x2715;
          </button>
        </div>

        {/* Body */}
        <div style={styles.body}>
          <span style={styles.icon} aria-label={getTigerResource("TIGER_QUERY_SEV_WARN")}>&#9888;</span>
          <span style={styles.message}>{getTigerResource("TIGER_RES_SURE")}</span>
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <button className="btn-acrylic-secondary" onClick={handleCancel}>
            {getTigerResource("TIGER_RES_CANCEL")}
          </button>
          <button className="btn-acrylic-primary" onClick={handleOk}>
            {getTigerResource("TIGER_RES_OK")}
          </button>
        </div>
      </div>
    </div>
  );
}
